export default "__VITE_ASSET__1cb47f34__"